export const GET_CLINIC_LISTING_CONST = 'GET_CLINIC_LISTING_CONST'

export const APPEND_CLIENT_LIST_WITH_SKELETON = 'APPEND_CLIENT_LIST_WITH_SKELETON'

export const CLEAR_CLINIC_LIST = 'CLEAR_CLINIC_LIST'
